import { apiconst } from "../utils/app-const";
import httpService from "./httpService";
export const authenticationService = {
    login,
    setRememberMe,
    setStore,
    CheckAuthentication
};

async function login(ChainEmail, Password, isChecked) {
    const chainEmail = ChainEmail.split(':');
    const response = await fetch(apiconst.ENDPOINT + apiconst.VERSION + apiconst.LOGIN, {
        method: "POST",
        headers: { "Content-Type": 'application/json' },
        body: JSON.stringify({ clientName: chainEmail[0], username: chainEmail[1], password: Password, RemenberMe: isChecked })
    });

    return await response.json();
}

async function setRememberMe(isRememberMe) {
    return await httpService.patch(apiconst.ENDPOINT + apiconst.VERSION + apiconst.REMEMBERME + "/" + isRememberMe, {});
}

async function setStore(isRememberMe, storeId) {
    return await httpService.patch(apiconst.ENDPOINT + apiconst.VERSION + apiconst.SETSTORE + "/" + isRememberMe + "/" + storeId, {});
}

async function CheckAuthentication() {
    return await httpService.get(apiconst.ENDPOINT + apiconst.VERSION + apiconst.CHECKAUTHENTICATION, {});
}